import { useEffect } from "react";
import { auth, db } from "../firebase/firebase";
import { useNavigate } from "react-router-dom";
import { signOut, sendEmailVerification } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

function VerificarEmail() {
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(async () => {
      if (auth.currentUser) {
        await auth.currentUser.reload();
  
        if (auth.currentUser.emailVerified) {
          const datos = JSON.parse(
            localStorage.getItem("registroPendiente")
          );
  
          if (datos) {
            await setDoc(doc(db, "users", auth.currentUser.uid), {
              email: auth.currentUser.email,
              emailVerificado: true,
              role: "paciente",
  
              nombre: datos.nombre,
              apellido: datos.apellido,
              dni: datos.dni,
              genero: datos.genero || "",
              telefono: datos.telefono,
  
              fechaNacimiento: datos.fechaNacimiento,
  
              pesoInicial: Number(datos.peso || 0),
              pesoActual: Number(datos.peso || 0),
              altura: Number(datos.altura || 0),
  
              createdAt: new Date(),
  
              lastWeightUpdate: new Date(),
              weightTrackingStart: new Date(),
              lastReminderSent: null,
              weightStatus: "activo"
            });
  
            localStorage.removeItem("registroPendiente");
          }
  
          clearInterval(interval);
          navigate("/dashboard");
        }
      }
    }, 3000);
  
    return () => clearInterval(interval);
  }, [navigate]);

  // 🔓 Cerrar sesión (para cambiar email)
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  // 🔁 Reenviar email
  const reenviarEmail = async () => {
    if (auth.currentUser) {
      await sendEmailVerification(auth.currentUser);
      alert("Correo reenviado 📩");
    }
  };

  // 🔄 Verificación manual
  const verificarManual = async () => {
    if (auth.currentUser) {
      await auth.currentUser.reload();
  
      if (auth.currentUser.emailVerified) {
        const datos = JSON.parse(
          localStorage.getItem("registroPendiente")
        );
  
        if (datos) {
          await setDoc(doc(db, "users", auth.currentUser.uid), {
            email: auth.currentUser.email,
            emailVerificado: true,
            role: "paciente",
  
            nombre: datos.nombre,
            apellido: datos.apellido,
            dni: datos.dni,
            telefono: datos.telefono,
  
            edad: Number(datos.edad || 0),
  
            pesoInicial: Number(datos.peso || 0),
            pesoActual: Number(datos.peso || 0),
            altura: Number(datos.altura || 0),
  
            createdAt: new Date(),
  
            lastWeightUpdate: new Date(),
            weightTrackingStart: new Date(),
            lastReminderSent: null,
            weightStatus: "activo"
          });
  
          localStorage.removeItem("registroPendiente");
        }
  
        navigate("/dashboard");
      } else {
        alert("Aún no verificaste el email");
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "80px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Card */}
      <div
        style={{
          width: "320px",
          padding: "25px",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          textAlign: "center",
          backgroundColor: "#fff",
        }}
      >
        <h2 style={{ marginBottom: "10px" }}>Verificá tu email 📩</h2>

        <p style={{ fontSize: "14px", color: "#555" }}>
          Enviamos un correo a:
        </p>

        {/* 📧 Email mostrado */}
        <p style={{ fontWeight: "bold", marginBottom: "15px" }}>
          {auth.currentUser?.email}
        </p>

        <p style={{ fontSize: "15px", color: "#777" }}>
          Revisá tu bandeja de SPAM.
        </p>

        <br />

        {/* Botones */}
        <button
          onClick={reenviarEmail}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            backgroundColor: "#4a90e2",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Reenviar correo
        </button>

       

        <button
          onClick={handleLogout}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "transparent",
            color: "#d0021b",
            border: "1px solid #d0021b",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Cambiar email
        </button>
      </div>
    </div>
  );
}

export default VerificarEmail;